import { render, staticRenderFns } from "./venueForm.vue?vue&type=template&id=008defc6&scoped=true"
import script from "./venueForm.vue?vue&type=script&lang=js"
export * from "./venueForm.vue?vue&type=script&lang=js"
import style0 from "./venueForm.vue?vue&type=style&index=0&id=008defc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008defc6",
  null
  
)

export default component.exports